import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneEnterRegForm.styl';


Vue.component('BXmakerAuthuserphoneEnterRegForm', {
    name: 'BXmakerAuthuserphoneEnterRegForm',
    data() {
        return {};
    },
    computed: {},
    methods: {

        onEnterFIO(value, item = null) {
            if (value) {
                this.$root.setFIO(value);
                this.$root.setDadataItem(item);
            }
            this.$refs.phone.focus();
        },
        onInputFIO(value) {
            this.$root.setFIO(value);
            this.$root.setDadataItem(null);
        },
        onEnterPhone() {
            if (this.$root.isEnabledRegisterLogin) {
                this.$refs.login.focus();
            } else {
                this.onEnterLogin();
            }
        },
        onChangePhone(data) {
            this.$root.setPhone(data.formattedValue);
        },
        onEnterLogin() {
            if (this.$root.isEnabledRegisterEmail) {
                this.$refs.email.focus();
            } else {
                this.onEnterEmail();
            }
        },
        onEnterEmail() {
            if (this.$root.isEnabledRegisterPassword) {
                this.$refs.password.focus();
            } else {
                this.onEnterPassword();
            }
        },
        onEnterPassword() {
            this.onClickConfirm();
        },
        onClickConfirm() {
            if (this.$root.isEnabledRequestConsent && !this.$root.isConsentReceived) {
                this.$refs.consent.showPopup();
                return;
            }

            if (this.$root.isFullCaptcha) {
                this.$root.register();
            }
        },
        onConsentAgree() {
            this.$root.consentAgree();

            if (this.$root.isFullCaptcha) {
                this.$root.register();
            }
        },

    },
    //language=Vue
    template: `
      <div class="bxmaker-authuserphone-enter-reg-form">

      <slot name="message">
        <BXmakerAuthuserphoneMessage :message="$root.message" :error="$root.error"/>
      </slot>

      <slot name="name" v-if="$root.isEnabledRegisterFIO">
        <BXmakerAuthuserphoneInputFIO
            :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REG_FORM_FIO"
            :value="$root.fio"
            @onInput="onInputFIO"
            @onEnter="onEnterFIO"
            name="FIO"
            :dadata="$root.registerFIODadata"
            ref="fio"
        />
      </slot>


      <slot name="phone">
        <BXmakerAuthuserphoneInputPhone 
            v-if="$root.isEnabledPhoneMaskTypeBitrix"
                                        :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REG_FORM_PHONE"
                                        :value="$root.phone"
                                        @onChange="onChangePhone"
                                        @onEnter="onEnterPhone"
                                        name="PHONE"
                                        :mask="$root.phoneMaskParams"
                                        ref="phone"
        />

        <BXmakerAuthuserphoneInput v-else
                                   :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REG_FORM_PHONE"
                                   :value="$root.phone"
                                   @onInput="$root.setPhone"
                                   @onEnter="onEnterPhone"
                                   name="PHONE"
                                   ref="phone"
                                   :mask="$root.phoneMaskParams"
                                   type="tel"
        />
      </slot>
      <slot name="login" v-if="$root.isEnabledRegisterLogin">
        <BXmakerAuthuserphoneInput
            :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REG_FORM_LOGIN"
            :value="$root.login"
            @onInput="$root.setLogin"
            @onEnter="onEnterLogin"
            name="LOGIN"
            ref="login"
        />
      </slot>
      <slot name="email" v-if="$root.isEnabledRegisterEmail">
        <BXmakerAuthuserphoneInput
            :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REG_FORM_EMAIL"
            :value="$root.email"
            @onInput="$root.setEmail"
            @onEnter="onEnterEmail"
            name="EMAIL"
            ref="email"
        />
      </slot>

      <slot name="pass" v-if="$root.isEnabledRegisterPassword">
        <BXmakerAuthuserphoneInputPassword
            :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REG_FORM_PASSWORD"
            :value="$root.password"
            @onInput="$root.setPassword"
            @onEnter="onEnterPassword"
            ref="password"
            name="PASSWORD"
        />
      </slot>


      <slot name="captcha">
        <BXmakerAuthuserphoneCaptcha
            :code="$root.captchaCode"
            :src="$root.captchaSrc"
            :length="$root.captchaLength"
            :loader="$root.captchaLoader"
            @onInput="$root.setCaptchaCode"
            @onComplete="onClickConfirm"
            @onRefresh="$root.refreshCaptcha"
        />
      </slot>

      <slot name="consent" v-if="$root.isEnabledRequestConsent">
        <BXmakerAuthuserphoneConsent
            :button="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REG_FORM_BUTTON"
            :text="$root.consentText"
            :isReceived="$root.isConsentReceived"
            @onAgree="onConsentAgree"
            @onDisagree="$root.consentDisagree"
            ref="consent"
        />
      </slot>


      <slot name="request">
        <BXmakerAuthuserphoneButton
            :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REG_FORM_BUTTON"
            :loader="$root.startLoader"
            @onClick="onClickConfirm"
        />
      </slot>


      </div>
    `,
});